
import { Bike, Home, CreditCard, Users, Package, Settings, User, BarChart, Map, Tag, CalendarCheck, CircleDollarSign, Smartphone, Receipt, Clock, Route, MessageSquare } from 'lucide-react';
import { LucideIcon } from 'lucide-react';

export interface MenuItem {
  title: string;
  path: string;
  icon: LucideIcon;
}

export const getAdminMenuItems = (): MenuItem[] => [
  {
    title: 'Главная',
    path: '/admin',
    icon: Home,
  },
  {
    title: 'Велосипеды',
    path: '/admin/bikes',
    icon: Bike,
  },
  {
    title: 'Аренды',
    path: '/admin/rentals',
    icon: Package,
  },
  {
    title: 'Курьеры',
    path: '/admin/couriers',
    icon: Users,
  },
  {
    title: 'Платежи',
    path: '/admin/payments',
    icon: CreditCard,
  },
  {
    title: 'Подписки',
    path: '/admin/subscriptions',
    icon: CircleDollarSign,
  },
  {
    title: 'Маршруты курьеров',
    path: '/admin/location-history',
    icon: Route,
  },
  {
    title: 'Аналитика',
    path: '/admin/analytics',
    icon: BarChart,
  },
  {
    title: 'Настройки',
    path: '/admin/settings',
    icon: Settings,
  },
];

export const getCourierMenuItems = (): MenuItem[] => [
  {
    title: 'Главная',
    path: '/courier',
    icon: Home,
  },
  {
    title: 'Профиль',
    path: '/courier/profile',
    icon: User,
  },
  {
    title: 'Мои маршруты',
    path: '/courier/location-history',
    icon: Route,
  },
  {
    title: 'Подписки',
    path: '/courier/subscriptions',
    icon: CircleDollarSign,
  },
  {
    title: 'Платежи',
    path: '/courier/payments',
    icon: CreditCard,
  },
  {
    title: 'Мой SIM',
    path: '/courier/mysim',
    icon: Smartphone,
  },
  {
    title: 'Выбрать тариф',
    path: '/courier/tariff',
    icon: Tag,
  },
];
